/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  HCPLandscapeDropdowns,
  HCPLandscapeDropdownsFromJSON,
  HCPLandscapeDropdownsFromJSONTyped,
  HCPLandscapeDropdownsToJSON,
} from "./";

/**
 *
 * @export
 * @interface HCPLandscapeDropdownsControllerResponse
 */
export interface HCPLandscapeDropdownsControllerResponse {
  /**
   *
   * @type {HCPLandscapeDropdowns}
   * @memberof HCPLandscapeDropdownsControllerResponse
   */
  data?: HCPLandscapeDropdowns;
  /**
   *
   * @type {ErrorResponse}
   * @memberof HCPLandscapeDropdownsControllerResponse
   */
  error?: ErrorResponse;
}

export function HCPLandscapeDropdownsControllerResponseFromJSON(json: any): HCPLandscapeDropdownsControllerResponse {
  return HCPLandscapeDropdownsControllerResponseFromJSONTyped(json, false);
}

export function HCPLandscapeDropdownsControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HCPLandscapeDropdownsControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : HCPLandscapeDropdownsFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function HCPLandscapeDropdownsControllerResponseToJSON(
  value?: HCPLandscapeDropdownsControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: HCPLandscapeDropdownsToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
